<template>
    <div class="loading">
        <slot>
            <Spinner  class="m-auto icon spinner" />
        </slot>
    </div>
</template>

<script>
import Spinner from '../../../animod-shop-ssr/src/assets/icons/spinner.svg';

export default {
    name: 'Loading',
    components: {
        Spinner
    }
}
</script>

<style scoped lang="scss">
    @use "../styles/variables";
    @use "sass:map";

    .loading {
        display: flex;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: hsla(0,0%,100%, 0.5);
        z-index: 3;

        .spinner {
            font-size: 30px;
            height: 1em;
            width: 1em;
            color: map.get(variables.$colors, 'primary');
            animation: spin 1s linear infinite;
        }

        @keyframes spin {
            100% { transform: rotate(360deg) }
        }
    }
</style>
